import React, {useRef, useState} from 'react';
import { Grid } from 'react-virtualized';
import 'react-virtualized/styles.css';
import FeaturesRow from "./FeaturesRow";
import {connect} from "react-redux";
import {getGridColumnDimensions, useGridDimensions} from "./gridDimensions";

const FeaturesGrid = ({ lookViewType, rows, featureGroup, isMobile, windowHeight, itemClickCallback, shouldShowFullHeight= false }) => {
  const containerRef = useRef(null);
  const [activeItemIndex, setActiveItemIndex] = useState(0);

  // Configuring the grid layout
  const {gridWidth, gridHeight} = useGridDimensions(windowHeight, isMobile);
  const {columnCount, rowHeight} = getGridColumnDimensions(lookViewType);
  const columnWidth = Math.floor(gridWidth / columnCount) - 8 / columnCount; // Ensure width is an integer to avoid overflow
  const rowCount = Math.ceil(rows.length / columnCount);

  return (
    <div className="side-level2__content-grid" ref={containerRef}>
      <Grid
        width={gridWidth}
        height={shouldShowFullHeight ? rowCount * rowHeight : gridHeight} // Use full container height
        columnCount={columnCount}
        columnWidth={columnWidth}
        rowCount={rowCount}
        rowHeight={rowHeight}
        cellRenderer={({ columnIndex, key, rowIndex, style }) => {
          const index = rowIndex * columnCount + columnIndex;
          if (index >= rows.length) return null;
          return (
            <FeaturesRow
              key={key}
              style={style}
              feature={rows[index].part ? rows[index].part : rows[index]}
              featureGroup={featureGroup}
              index={index}
              activeItemIndex={activeItemIndex}
              setActiveItemIndex={setActiveItemIndex}
              itemClickCallback={itemClickCallback}
            />
          );
        }}
      />
    </div>
  );
};

const mapStateToProps = (store) => {
  const { isMobile } = store.serverState;
  const { lookViewType } = store.lookState;

  return {
    isMobile,
    lookViewType,
  };
};

export default connect(mapStateToProps)(FeaturesGrid);
